import { defineMessages } from "@/i18n";
import en from "./en";

export const searchFrameMessages = defineMessages("frames-search", en);
